import * as React from "react"
import PropTypes from "prop-types"
import SEO from "../components/seo"
import Slider from "./slider"

const Carousel = ({ site, siteTitle }) => (
  <div
    className="relative container mx-auto"
    style={{ maxWidth: "100%", marginTop: "-25rem", display: "block" }}
  >
    <Slider site={site} />
    <SEO title="Slider" />

    <div className="carousel-inner relative w-full">
      <div className="containerBTON">
        <div className="circulo-bton-flotante">
          <a
            href="https://wa.me/+573172593566?text=Hola"
            target="_blank"
            title="Chatea con nosotros las 24 horas Mediante Whatsapp!"
            alt="Chatea con nosotros las 24 horas Mediante Whatsapp!"
          >
            <div
              className="grid grid-cols-2 gap-4"
              style={{ top: "3rem", position: "relative", left: "1.6rem" }}
            >
              <div tabIndex="2">
                <div
                  style={{
                    left: "45%",
                    width: "3rem",
                    height: "3rem",
                    boxShadow: "0px 1px 10px rgba(0,0,0,0.4)",
                  }}
                  className="relative p-0 w-10 h-10 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
                >
                  <img
                    className="relative icono_boton_flotante_rueda"
                    style={{ left: "9px", top: "8px" }}
                    src={
                      process.env.GATSBY_API_URL +
                      "/uploads/ico_chat_a142bf4b6f.png"
                    }
                    formats={["auto", "webp", "avif"]}
                    width={35}
                    height={35}
                    alt="Boton chat"
                    title="Boton chat"
                  />
                </div>
              </div>
              <div
                style={{ position: "relative", top: "0.5rem", right: "4rem" }}
                className="text-poppins-regular green-primary"
              >
                Chat
              </div>
            </div>
          </a>
          <div className="bton_redes_sociales" style={{ cursor: "pointer" }}>
            <div
              className="grid grid-cols-2 gap-4"
              style={{ top: "5rem", position: "relative", right: "3rem" }}
            >
              <div tabIndex="2">
                <div
                  style={{
                    left: "45%",
                    width: "3rem",
                    height: "3rem",
                    boxShadow: "0px 1px 10px rgba(0,0,0,0.4)",
                  }}
                  className="relative p-0 w-10 h-10 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
                >
                  <img
                    className="relative icono_boton_flotante_rueda"
                    style={{ left: "9px", top: "9px" }}
                    src={
                      process.env.GATSBY_API_URL +
                      "/uploads/ico_instagram_verde_8270e08fbb.png"
                    }
                    formats={["auto", "webp", "avif"]}
                    width={35}
                    height={35}
                    alt="Boton redes sociales"
                    title="Boton redes sociales"
                  />
                </div>
              </div>
              <div
                style={{ position: "relative", top: "0.5rem", right: "4rem" }}
                className="text-poppins-regular green-primary"
              >
                Redes <br></br> Sociales
              </div>
            </div>
          </div>

          <div className="bton_telefonos" style={{ cursor: "pointer" }}>
            <div
              className="grid grid-cols-2 gap-4"
              style={{ top: "7.4rem", position: "relative", left: "-3rem" }}
            >
              <div tabIndex="2">
                <div
                  style={{
                    left: "45%",
                    width: "3rem",
                    height: "3rem",
                    boxShadow: "0px 1px 10px rgba(0,0,0,0.4)",
                  }}
                  className="relative p-0 w-10 h-10 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
                >
                  <img
                    className="relative icono_boton_flotante_rueda"
                    style={{ left: "9px", top: "9px" }}
                    src={
                      process.env.GATSBY_API_URL +
                      "/uploads/ico_tel_actualizado_f401d6b474.png"
                    }
                    formats={["auto", "webp", "avif"]}
                    width={35}
                    height={35}
                    title="Boton linea de atenión"
                    alt="Boton linea de atenión"
                  />
                </div>
              </div>

              <div
                style={{ position: "relative", top: "0.5rem", right: "4rem" }}
                className="text-poppins-regular green-primary"
              >
                Llámanos
              </div>
            </div>
          </div>

          <a href="/personas/pqrs" tabIndex="2">
            <div
              className="bton_pqrs grid grid-cols-2 gap-4"
              style={{ top: "8.5rem", position: "relative", left: "1rem" }}
            >
              <div>
                <div
                  style={{
                    left: "45%",
                    width: "3rem",
                    height: "3rem",
                    boxShadow: "0px 1px 10px rgba(0,0,0,0.4)",
                    cursor: "pointer",
                  }}
                  className="relative p-0 w-10 h-10 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
                >
                  <img
                    className="relative icono_boton_flotante_rueda"
                    style={{ left: "9px", top: "9px" }}
                    src={
                      process.env.GATSBY_API_URL +
                      "/uploads/ico_pqrs_actualizado_faad60a12f.png"
                    }
                    formats={["auto", "webp", "avif"]}
                    width={35}
                    height={35}
                    alt="Boton enlace pqrs"
                    title="Boton enlace pqrs"
                  />
                </div>
              </div>

              <div
                style={{ position: "relative", top: "0.5rem", right: "4rem" }}
                className="text-poppins-regular green-primary"
              >
                PQRS <br></br> ¿Te ayudamos?
              </div>
            </div>
          </a>
        </div>
        {/* Rueda flotante de REDES SOCIALES */}

        <div className="circulo-bton-flotante-redes-sociales">
          <a href="https://es-la.facebook.com/epsdelagente/" target="_blank">
            <div
              className="grid grid-cols-2 gap-4"
              style={{ top: "3rem", position: "relative", left: "1.6rem" }}
            >
              <div tabIndex="2">
                <div
                  style={{
                    left: "45%",
                    width: "3rem",
                    height: "3rem",
                    boxShadow: "0px 1px 10px rgba(0,0,0,0.4)",
                  }}
                  className="relative p-0 w-10 h-10 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
                >
                  <img
                    className="relative icono_boton_flotante_rueda"
                    style={{ left: "9px", top: "8px" }}
                    src={
                      process.env.GATSBY_API_URL +
                      "/uploads/ico_facebook_dab54873d3.png"
                    }
                    formats={["auto", "webp", "avif"]}
                    width={35}
                    height={35}
                    alt="ico_facebook"
                    title="ico_facebook"
                  />
                </div>
              </div>
              <div
                style={{ position: "relative", top: "0.5rem", right: "4rem" }}
                className="text-poppins-regular green-primary"
              >
                Facebook
              </div>
            </div>
          </a>
          <a href="https://www.instagram.com/epsdelagente/" target="_blank">
            <div
              className="grid grid-cols-2 gap-4"
              style={{ top: "7rem", position: "relative", right: "3rem" }}
            >
              <div tabIndex="2">
                <div
                  style={{
                    left: "45%",
                    width: "3rem",
                    height: "3rem",
                    boxShadow: "0px 1px 10px rgba(0,0,0,0.4)",
                  }}
                  className="relative p-0 w-10 h-10 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
                >
                  <img
                    className="relative icono_boton_flotante_rueda"
                    style={{ left: "9px", top: "9px" }}
                    src={
                      process.env.GATSBY_API_URL +
                      "/uploads/ico_instagram_661880e70f.png"
                    }
                    formats={["auto", "webp", "avif"]}
                    width={35}
                    height={35}
                    title="ico_instagram"
                    alt="ico_instagram"
                  />
                </div>
              </div>
              <div
                style={{ position: "relative", top: "0.5rem", right: "4rem" }}
                className="text-poppins-regular green-primary"
              >
                Instagram
              </div>
            </div>
          </a>

          <a
            href="https://www.youtube.com/channel/UC6QTJqXwWGkHfkdbJBAQ60g"
            target="_blank"
          >
            <div
              className="grid grid-cols-2 gap-4"
              style={{ top: "11.5rem", position: "relative", left: "2.1rem" }}
            >
              <div tabIndex="2">
                <div
                  style={{
                    left: "45%",
                    width: "3rem",
                    height: "3rem",
                    boxShadow: "0px 1px 10px rgba(0,0,0,0.4)",
                  }}
                  className="relative p-0 w-10 h-10 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
                >
                  <img
                    className="relative icono_boton_flotante_rueda"
                    style={{ left: "9px", top: "9px" }}
                    src={
                      process.env.GATSBY_API_URL +
                      "/uploads/ico_youtube_ed93f17291.png"
                    }
                    formats={["auto", "webp", "avif"]}
                    width={35}
                    height={35}
                    alt="ico_youtube"
                    title="ico_youtube"
                  />
                </div>
              </div>
              <div
                style={{ position: "relative", top: "0.5rem", right: "4rem" }}
                className="text-poppins-regular green-primary"
              >
                YouTube
              </div>
            </div>
          </a>
        </div>

        {/* Fin de Rueda de REDES SOCIALES */}

        {/* Rueda flotante de TELEFONO */}

        <div className="circulo-bton-flotante-telefonos">
          <div
            className="grid grid-cols-1 gap-4"
            style={{ top: "3.5rem", position: "relative", left: "12.6rem" }}
          >
            <div
              tabIndex="2"
              style={{ position: "relative", top: "1.5rem", right: "5rem" }}
              className="text-poppins-regular green-primary"
            >
              Línea de atención: <br></br>{" "}
              <span className="text-poppins-bold">(602) 4853530</span>
            </div>
          </div>

          <img
            style={{
              position: "absolute",
              left: "4rem",
              top: "7rem",
              width: "3rem",
              height: "3rem",
              transform: "none",
            }}
            src={
              process.env.GATSBY_API_URL + "/uploads/curved_line_c68e1e07a5.png"
            }
            formats={["auto", "webp", "avif"]}
            width={35}
            height={35}
            alt="curved_line"
            title="curved_line"
          />
          <div
            className="grid grid-cols-1 gap-4"
            style={{ top: "7.9rem", position: "relative", left: "-8rem" }}
          >
            <div tabIndex="2">
              <div
                style={{
                  left: "45%",
                  width: "3rem",
                  height: "3rem",
                  boxShadow: "0px 1px 10px rgba(0,0,0,0.4)",
                  cursor: "pointer",
                }}
                className="relative p-0 w-10 h-10 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
              >
                <img
                  className="relative icono_boton_flotante_rueda"
                  style={{ left: "9px", top: "9px" }}
                  src={
                    process.env.GATSBY_API_URL +
                    "/uploads/ico_tel_actualizado_f401d6b474.png"
                  }
                  formats={["auto", "webp", "avif"]}
                  width={35}
                  height={35}
                  alt="Boton llamada de atención"
                  title="Boton llamada de atención"
                />
              </div>
            </div>
          </div>
          <img
            style={{
              position: "absolute",
              left: "3.5rem",
              top: "15rem",
              width: "3rem",
              height: "3rem",
              transform: "rotate(284deg)",
            }}
            src={
              process.env.GATSBY_API_URL + "/uploads/curved_line_c68e1e07a5.png"
            }
            formats={["auto", "webp", "avif"]}
            width={35}
            height={35}
            alt="curved_line"
            title="curved_line"
          />
          <div
            className="grid grid-cols-1 gap-4"
            tabIndex="2"
            style={{ top: "8.5rem", position: "relative", left: "1rem" }}
          >
            <div
              style={{ position: "relative", top: "2.5rem", left: "6rem" }}
              className="text-poppins-regular color-texto-parrafo"
            >
              Atención nacional: <br></br>{" "}
              <span className="text-poppins-bold">018000185462</span>
            </div>
          </div>
        </div>

        {/* Fin de Rueda de TELEFONOS */}

        <div className="btn-mas" tabIndex="2">
          <label htmlFor="btn-mas">
            <img
              width={135}
              height={135}
              src={
                process.env.GATSBY_API_URL +
                "/uploads/boton_contacto_VER_2_5bc5751875.png"
              }
              formats={["auto", "webp", "avif"]}
              alt="Boton aqui te ayudamos"
              title="Boton aqui te ayudamos"
            />
          </label>
        </div>

        <div
          style={{ position: "relative", bottom: "0rem", right: "-1rem" }}
          tabIndex="2"
          className="btn-cruz"
        >
          <label
            style={{ cursor: "pointer", position: "relative", bottom: "-5px" }}
            className="fa fa-plus"
          ></label>
        </div>

        <div
          style={{ position: "relative", bottom: "4rem", right: "-1rem" }}
          className="btn-cruz-redes-sociales"
          tabIndex="2"
        >
          <label
            style={{ cursor: "pointer", position: "relative", bottom: "-5px" }}
            className="fa fa-plus"
          ></label>
        </div>

        <div
          style={{ position: "relative", bottom: "7rem", right: "-1rem" }}
          className="btn-cruz-telefonos"
          tabIndex="2"
        >
          <label
            style={{ cursor: "pointer", position: "relative", bottom: "-5px" }}
            className="fa fa-plus"
          ></label>
        </div>
      </div>
    </div>
  </div>
)

Carousel.propTypes = {
  siteTitle: PropTypes.string,
}

Carousel.defaultProps = {
  siteTitle: ``,
}

export default Carousel
